var map = {
	"./img_defray_title_cn.png": "zq7u",
	"./img_defray_title_de.png": "GgOs",
	"./img_defray_title_en.png": "A6lO",
	"./img_defray_title_es.png": "VXBL",
	"./img_defray_title_fr.png": "0CZy",
	"./img_defray_title_it.png": "TQJ1",
	"./img_defray_title_jp.png": "evH5",
	"./img_defray_title_pt.png": "FBlg",
	"./img_defray_title_tw.png": "Unfn"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6l1u";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newYear-2023 ^\.\/img_defray_title_.*\.png$
// module id = 6l1u
// module chunks = 1